import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui";
import { Input } from "../ui";
import { Button } from "../ui";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui";
import { TextareaComponent } from "../ui";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui";
import { Alert, AlertDescription } from "../ui";
import { ImagePlus, Check } from "lucide-react";
import { categoryService } from "../../services/categoryService";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

const Categorias = ({ editingCategory, setEditingCategory }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [formData, setFormData] = useState({
    name: "", // Cambiado de nombre a name
    destination: "", // Cambiado de destino a destination
    description: "", // Cambiado de descripcion a description
    image: null, // Cambiado de imagen a image
  });

  useEffect(() => {
    if (editingCategory) {
      setFormData({
        name: editingCategory.name || "",
        destination: editingCategory.destination?.toLowerCase() || "",
        description: editingCategory.description || "",
        image: editingCategory.image || null,
      });
    }
  }, [editingCategory]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));
    }
  };

  const validateForm = () => {
    const requiredFields = {
      name: "Nombre",
      destination: "Destino",
      // Eliminamos description de los campos requeridos
    };

    const missingFields = Object.entries(requiredFields)
      .filter(([key]) => !formData[key])
      .map(([, label]) => label);

    if (missingFields.length > 0) {
      toast.error(`Por favor complete los campos: ${missingFields.join(", ")}`);
      return false;
    }

    return true;
  };

  const handleConfirm = async () => {
    if (!validateForm()) {
      setShowConfirmDialog(false);
      return;
    }

    setLoading(true);
    try {
      // Asegurarnos de que destination esté en mayúsculas
      const serviceData = {
        ...formData,
        destination: formData.destination.toUpperCase(),
      };

      let response;
      if (editingCategory) {
        response = await categoryService.updateCategory(
          editingCategory.id,
          serviceData
        );
      } else {
        response = await categoryService.createCategory(serviceData);
      }

      setShowConfirmDialog(false);

      if (response.success) {
        toast.success(response.message);
        setShowSuccessAlert(true);

        // Resetear el formulario
        setFormData({
          name: "",
          destination: "",
          description: "",
          image: null,
        });

        if (editingCategory) {
          setEditingCategory(null);
        }

        setTimeout(() => {
          setShowSuccessAlert(false);
          navigate("/dashboard/admCategorias");
        }, 3000);
      } else {
        toast.error(response.message || "Error al procesar la categoría");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.message || "Error al procesar la categoría");
      setShowConfirmDialog(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setShowConfirmDialog(true);
    }
  };

  return (
    <div className="min-h-screen bg-orange-50 p-6">
      <Card className="max-w-2xl mx-auto">
        <CardHeader>
          <CardTitle>
            {editingCategory ? "Modificar" : "Agregar"} Categoría
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Imagen de Categoría */}
          <div>
            <h3 className="text-lg font-medium mb-2">Imagen de Categoría</h3>
            <div
              className="border-2 border-dashed border-orange-200 rounded-lg p-6 text-center cursor-pointer hover:border-orange-300"
              onClick={() => document.getElementById("imageUpload").click()}
            >
              <ImagePlus className="w-12 h-12 mx-auto text-orange-300" />
              <p className="mt-2 text-sm text-gray-500">
                Click para subir imagen
              </p>
              <input
                id="imageUpload"
                type="file"
                className="hidden"
                accept="image/*"
                onChange={handleImageUpload}
              />
              {formData.image && (
                <p className="mt-2 text-sm text-green-600">
                  Imagen seleccionada: {formData.image.name}
                </p>
              )}
            </div>
          </div>

          {/* Nombre de Categoría */}
          <div>
            <h3 className="text-lg font-medium mb-2">Nombre de Categoría *</h3>
            <Input
              placeholder="Escribe aquí el nombre"
              value={formData.name}
              onChange={(e) => handleInputChange("name", e.target.value)}
              className="border-orange-200 focus:ring-orange-200 focus:border-orange-300"
            />
          </div>

          {/* Destino */}
          <div>
            <h3 className="text-lg font-medium mb-2">Destino *</h3>
            <Select
              value={formData.destination}
              onValueChange={(value) => handleInputChange("destination", value)}
            >
              <SelectTrigger>
                <SelectValue placeholder="Selecciona el destino" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="barra">Barra</SelectItem>
                <SelectItem value="cocina">Cocina</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Descripción */}
          <div>
            <h3 className="text-lg font-medium mb-2">
              Descripción
              <span className="text-sm text-gray-500 ml-2">(Opcional)</span>
            </h3>
            <TextareaComponent
              placeholder="Escribe aquí la descripción (opcional)"
              value={formData.description}
              onChange={(e) => handleInputChange("description", e.target.value)}
              className="border-orange-200 focus:ring-orange-200 focus:border-orange-300 min-h-[100px]"
            />
          </div>

          {/* Botón Agregar/Modificar */}
          <Button
            className="w-full bg-orange-500 hover:bg-orange-600 text-white"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading
              ? "Procesando..."
              : editingCategory
              ? "Modificar"
              : "Agregar"}
          </Button>
        </CardContent>
      </Card>

      {/* Diálogo de confirmación */}
      <AlertDialog open={showConfirmDialog} onOpenChange={setShowConfirmDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Confirmar</AlertDialogTitle>
            <AlertDialogDescription>
              ¿Está seguro que desea {editingCategory ? "modificar" : "agregar"}{" "}
              esta categoría?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="bg-gray-100 hover:bg-gray-200">
              Cancelar
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={handleConfirm}
              className="bg-orange-500 hover:bg-orange-600"
              disabled={loading}
            >
              {loading ? "Procesando..." : "Confirmar"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Alerta de éxito */}
      {showSuccessAlert && (
        <Alert className="fixed bottom-4 right-4 max-w-md bg-green-50 border-green-500">
          <Check className="h-4 w-4 text-green-600" />
          <AlertDescription className="text-green-600">
            Categoría {editingCategory ? "modificada" : "agregada"}{" "}
            exitosamente. Puede verla{" "}
            <span
              className="underline cursor-pointer"
              onClick={() => navigate("/dashboard/admCategorias")}
            >
              AQUÍ
            </span>{" "}
            o {editingCategory ? "modificar" : "agregar"} otra haciendo click{" "}
            <span
              className="underline cursor-pointer"
              onClick={() => {
                setShowSuccessAlert(false);
                setFormData({
                  name: "",
                  destination: "",
                  description: "",
                  image: null,
                });
              }}
            >
              aquí
            </span>
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
};

export default Categorias;
